<mat-spinner *ngIf="loading" style="margin: 90px auto;"></mat-spinner>

<div [ngStyle]="{'display': (loading?'none':'inherit')}">

    <mat-card>
        <mat-card-header>
            <mat-card-title>Wykaz użytkowników</mat-card-title>
            <mat-card-subtitle>Zarządzanie kontami użytkowników</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <mat-form-field>
                <mat-label>Rola</mat-label>
                <mat-select [(ngModel)]="role" name="role" (selectionChange)="applySelect()">
                    <mat-option value="carrier">Transportujący/Dyspozytor</mat-option>
                    <mat-option value="driver">Kierowca</mat-option>
                    <mat-option value="user">Użytkownik</mat-option>
                    <mat-option value="administrator">Administrator</mat-option>
                </mat-select>
            </mat-form-field>


            <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef style="min-width: 100px">
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()">
                            <span style="width: 100px">&nbsp;</span>
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Nazwa </th>
                    <td mat-cell *matCellDef="let element"> {{element.firstName}} {{element.lastName}} </td>
                </ng-container>
                <ng-container matColumnDef="username">
                    <th mat-header-cell *matHeaderCellDef> Adres e-mail </th>
                    <td mat-cell *matCellDef="let element"> {{element.username}} </td>
                </ng-container>
                <ng-container matColumnDef="group">
                    <th mat-header-cell *matHeaderCellDef> Rola </th>
                    <td mat-cell *matCellDef="let element"> {{element.group?.name}} </td>
                </ng-container>
                <ng-container matColumnDef="phoneNumber">
                    <th mat-header-cell *matHeaderCellDef> Numer telefonu </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.phoneNumber == null ? '(brak)' : element.phoneNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="subject">
                    <th mat-header-cell *matHeaderCellDef> Podmiot </th>
                    <td mat-cell *matCellDef="let element"> {{element.selectedSubject?.name}} </td>
                </ng-container>
                <ng-container matColumnDef="creationDate">
                    <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.creationDate != undefined ? this.datepipe.transform(element.creationDate, 'dd.MM.yyyy HH:mm') : "(brak danych)"}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="activationDate">
                    <th mat-header-cell *matHeaderCellDef> Data aktywowania </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.isActive ? (element.activationDate != undefined ? this.datepipe.transform(element.activationDate, 'dd.MM.yyyy HH:mm') : "(brak danych)") : "-"}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="integrationDate">
                    <th mat-header-cell *matHeaderCellDef> Data powiązania </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.selectedSubject != undefined ? (element.selectedSubject.creationDate != undefined ? this.datepipe.transform(element.selectedSubject.creationDate, 'dd.MM.yyyy HH:mm') : "(brak-danych)") : "-"}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="details">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-form-field style="float:right;">
                            <input matInput autocomplete="off" (keyup)="applyFilter($event.target.value)" placeholder="Filtruj">
                        </mat-form-field>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index;" style="text-align: right;">
                        <button mat-button color="primary"
                            *ngIf="element.group?.name === 'Dyspozytor' || element.group?.name === 'Transportujący' || element.group?.name === 'Użytkownik'"
                            (click)="openSubjectWizardDialog('edit', element)">Podmioty</button>
                        <!-- <button mat-button color="primary" (click)="openDialog('view', element)">Podgląd</button> -->
                        <button mat-button color="primary" (click)="openDialog('edit', element)">Edytuj</button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>

            <div class="user-tools">

                <button mat-button color="warn" (click)="deleteSelected()"
                    [disabled]="selection == null || selection.selected.length==0">Usuń</button>
                <!-- <button mat-button color="basic" [matMenuTriggerFor]="menuExport">Eksport</button>
                <mat-menu #menuExport="matMenu">
                    <button (click)="exportData()" mat-menu-item>Do pliku JSON</button>
                </mat-menu> -->


                <button mat-flat-button color="primary" (click)="openDialog('create')" style="float:right">Dodaj
                    konto</button>
            </div>
        </mat-card-content>
    </mat-card>
</div>